import clsx from "clsx";
import styles from "./STTextarea.module.css";

export const STTextarea = ({
  label,
  placeholder,
  variant = "dark",
  error,
  disabled,
  rows = 3,
  className,
  handleChange,
  ...props
}) => {
  return (
    <div
      className={clsx(
        styles.wrapper,
        styles[variant],
        error && styles.error,
        disabled && styles.disabled,
        className
      )}
    >
      {label && <label className={styles.label}>{label}</label>}

      <div className={styles.field}>
        <textarea
          className={styles.textarea}
          placeholder={placeholder}
          disabled={disabled}
          rows={rows}
          onChange={handleChange}
          {...props}
        />
      </div>

      {error && <p className={styles.errorText}>{error}</p>}
    </div>
  );
};
